import { Component, Input, OnInit } from '@angular/core';
import { LifecycleAware, ModalService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';

@LifecycleAware()
@Component({
    selector: 'mark-purchase-request-modal',
    templateUrl: './mark-purchase-request-modal.component.html',
    styleUrls: ['./mark-purchase-request-modal.component.scss']
})
export class MarkPurchaseRequestModalComponent implements OnInit {
    purchaseRequest: { id: string; soldDate: string };
    newStatusI18n: string;
    newDate: Date;

    private readonly soldI18n = this._i18n('sold');
    private readonly pendingI18n = this._i18n('pending');

    constructor(private _i18n: I18n, private _modalService: ModalService) {}

    ngOnInit(): void {
        this.purchaseRequest = this._modalService.modal.data.purchaseRequest;
        this.newStatusI18n = this.purchaseRequest.soldDate ? this.pendingI18n : this.soldI18n;
    }

    onDateChange(date: Date) {
        if (date) {
            this._modalService.modal.data.soldDate$.next(date.toISOString().substring(0, 10));
        }
    }
}
